// @flow
import * as React from 'react'
import { FormattedMessage } from 'mz-intl'
import type { Flight } from 'mz-sdk/services/flights/getFlights'
import FieldHelp from '../FieldHelp'
import Button from '../../core/Button'
import BasicFlightField from './BasicFlightField'
import FlightFinderTool from './FlightFinderTool'
import ValidateSelectedFlight from './ValidateSelectedFlight'
import type { Appearance as FieldAppearance } from '../../core/BaseField'
import messages from './messages.intl'

// Types
import type { Props as FlightFieldProps } from './BasicFlightField'

export type Value = Flight
export type Appearance = 'desktop' | 'mobile'
export type Props = FlightFieldProps & {
  searchId?: string,
  finderAppearance?: Appearance,
  finderFieldsAppearance?: FieldAppearance,
  disableFinderTool?: boolean,
  disableFlightValidation?: boolean,
}

/**
 * Creates a part of the reservation data related with selected flight
 * @param  {Flight} flight   Selected flight
 * @param  {string} prefix   Prefix for the data fields (usually `return_`)
 * @return {Object}
 */
export function getFlightReservationData(flight: ?Value, prefix: string = '') {
  if (!flight) return null
  return {
    [`${prefix}airline`]:
      flight.airlineCode || flight.flightCode.substring(0, 2),
    [`${prefix}flight_number`]: flight.flightNumber,
  }
}

/**
 * Wrapper around FlightField which adds a lightbox with
 * extra fields to find a flight. It manages all the state
 * internally.
 */
class FlightFinderField extends React.Component<Props> {
  static defaultProps = BasicFlightField.defaultProps

  lightboxController = null

  flightSelectRef = null

  handleOpenLightbox = () => {
    this.flightSelectRef && this.flightSelectRef.hideOptions()
    this.lightboxController && this.lightboxController.open()
  }

  render() {
    return (
      <div>
        <FlightFinderTool
          appearance={
            this.props.finderFieldsAppearance || this.props.appearance
          }
          flightInfo={this.props.flightInfo}
          controllerRef={(c) => (this.lightboxController = c)}
          finderAppearance={this.props.finderAppearance}
          onSelectFlight={this.props.input.onChange}
        />
        <BasicFlightField
          {...this.props}
          innerRef={(c) => (this.flightSelectRef = c)}
          onOpenFinder={this.handleOpenLightbox}
        />
        {!this.props.disableFinderTool && (
          <FieldHelp>
            <FormattedMessage
              message={messages.FLIGHT_FINDER_TOOL_TIP}
              values={{
                link: (
                  <Button appearance="link" onClick={this.handleOpenLightbox}>
                    <FormattedMessage message={messages.FLIGHT_FINED_LINK} />
                  </Button>
                ),
              }}
            />
          </FieldHelp>
        )}
        {this.props.input.value && !this.props.disableFlightValidation && (
          <ValidateSelectedFlight
            flight={this.props.input.value}
            flightInfo={this.props.flightInfo}
            searchId={this.props.searchId}
          />
        )}
      </div>
    )
  }
}

export default FlightFinderField
